import { doc, serverTimestamp } from 'firebase/firestore'
import { eventInterestId, setInterestId } from '@shared/firestore'
import { db } from './firebase'
import { setDoc, updateDoc, deleteDoc } from './firestore'
import type { EventAttendanceStatus, InterestStatus, PartialRange } from '../types'

// New interests get a deterministic id, so two mounted writers (or a client
// racing a seed trigger) converge on one doc. `merge` keeps a racing writer's
// extra fields (a trigger's createdAt) so the write passes the status-only
// update rule. Existing docs may carry legacy auto ids — mutate them by the id
// the caller's query returned.

export async function writeEventInterest(
  userId: string,
  eventId: string,
  existingId: string | null,
  next: EventAttendanceStatus | 'none',
): Promise<void> {
  if (!existingId) {
    if (next === 'none') return
    await setDoc(doc(db, 'eventInterests', eventInterestId(userId, eventId)), { userId, eventId, status: next, updatedAt: serverTimestamp() }, { merge: true })
  } else if (next === 'none') {
    await deleteDoc(doc(db, 'eventInterests', existingId))
  } else {
    await updateDoc(doc(db, 'eventInterests', existingId), { status: next, updatedAt: serverTimestamp() })
  }
}

export function createSetInterest(
  userId: string,
  eventId: string,
  setId: string,
  status: InterestStatus,
  partialRange?: PartialRange,
): Promise<void> {
  return setDoc(
    doc(db, 'setInterests', setInterestId(userId, setId)),
    { userId, eventId, setId, status, ...(partialRange ? { partialRange } : {}) },
    { merge: true },
  )
}
